// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rfk-1","col":"styles_col__3WEr3"};